<template>
  <div class="label-container has-no-style">
    <div :class="isColumn ? 'column label-inner style-wrap' : 'label-inner style-wrap'" :style="getTextStyle" @click.stop="textClickEvent">
      <span
        v-if="(getIconPosition === 'right' || getIconPosition === 'bottom') && !isEditStatu"
        :class="contentHasLimit ? 'overflowHidMultiLine' : ''"
        :style="colorStyle"
        v-html="getTextContent"
        @dblclick.self="dbEditContent($event)"
      ></span>
      <input  v-if="(getIconPosition === 'right' || getIconPosition === 'bottom') && isEditStatu"
              ref="buttonInp"
              @blur="blueEvent"
              class="button-inp" v-model="tempContent"type="text" >
      <cxIcon v-if="iconSrc" :options="getDynamicOptions" :iconStyle="getIconStyle"></cxIcon>
      <input v-if="(getIconPosition === 'left' || getIconPosition === 'top') && isEditStatu" type="text"
             ref="buttonInp"
             @blur="blueEvent"
             class="button-inp" v-model="tempContent"  >
      <span
        v-if="(getIconPosition === 'left' || getIconPosition === 'top') && !isEditStatu"
        :class="contentHasLimit ? 'overflowHidMultiLine' : ''"
        :style="colorStyle"
        v-html="getTextContent"
        @dblclick.self="dbEditContent($event)"
      ></span>
    </div>
  </div>
</template>

<script>
import { spliceLinkUrl } from "utils"
import { isSsrPage } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxLabel",
  props: {
    type: { type: String },
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconContent: "",
      showDialog: false,
      rectOptions: {},
      contentResult: "",
      matched: false,
      reloadTimer: null,
      isEditStatu: false,
      tempContent:""
    }
  },
  watch: {
  "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n && this.noCacheComponent) {
          this.updateData()
        }
      }
    },
  },
  created() {
    this.options.conditionList.forEach(item => {
      const { value, result } = item
      item.value = value.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
      item.result = result.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDownEvent)
  },
  mounted() {
    ////编辑页不需要运行插件就在插件内部通过isSsrPage来判断环境后，再由插件内部自行决定是否运行
    this.$initPlugin(this.options?.pluginName)
    this.updateData()
    if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
      this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
    }
    this.$nextTick(()=>{
      document.addEventListener("keydown", this.keyDownEvent)
    })
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  computed: {
    noCacheComponent() {
      return this.options.noCacheComponent
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    contentHasLimit() {
      return this.options && this.options.contentHasLimit ? this.options.contentHasLimit : false
    },
    getTextContent() {
      let content = this.options
        ? String(this.matched ? this.contentResult : this.fieldValue || this.options.content)
            ?.replace("&lt;&gt;", "<>")
            .replace(/(<br>)*$/g, "")
        : ""
      let data = this.contentHasLimit ? content?.substr(0, this.options.textLimitLines) : content
      // 添加直接省略和添加省略号
      data = this.options.wordOmitType === "ellipsis" && content && content.length > this.options.textLimitLines ?
        data+'...'
        :data
      return data
    },
    // 优先匹配数据项，再匹配自身数据
    getContent() {
      let content = this.options
        ? String(this.fieldValue || this.options.content)
            ?.replace("&lt;&gt;", "<>")
            .replace(/(<br>)*$/g, "")
        : ""
      return content
    },
    currentFiledMapping() {
      return this.options.currentFiledMapping
    },
    fieldValue() {
      const dataType = this.currentFiledMapping?.dataType 
      const field = (this.options.fieldList || []).find(item => item.label === this.options.fieldValue)
      if (field) {
        if (dataType) {
          // 说明有显示配置
          let content = ""
          switch (dataType) {
            case "dataName":
              content = field.label; break;
            case "dataValue":
              content = field.value; break;
            case "dataKey":
              content = `${field.label}: ${field.value}`;break;
            default:
              content = field.value;
          }
          return content
        } else {
          return field.value
        }
      } else {
        return ""
      }
      // return field ? field.value : ""
    },
    iconSrc() {
      const options = this.getDynamicOptions
      let iconSrc
      let iconSrcType = Number(options.iconSrcType)
      switch (iconSrcType) {
        case 0:
          iconSrc = options.iconSrc
          break
        case 1:
          iconSrc = options.hoverIconSrc
          break
        case 2:
          iconSrc = options.clickIconSrc
          break
        default:
          iconSrc = options.iconSrc
      }
      return iconSrc && options.showIcon !== false
    },
    iconType() {
      const options = this.getDynamicOptions
      return options ? options.iconType : "img"
    },
    getIconPosition() {
      const options = this.getDynamicOptions
      return options ? options.iconPosition : "left"
    },
    isColumn() {
      const options = this.getDynamicOptions
      if (this.getIconPosition === "top" || this.getIconPosition === "bottom") {
        return true
      } else {
        return false
      }
    },
    getMargin() {
      const options = this.getDynamicOptions
      return options.iconPosition === "left"
        ? `0 ${options.iconMargin}px 0 0`
        : options.iconPosition === "right"
        ? `0 0 0 ${options.iconMargin}px`
        : options.iconPosition === "top"
        ? `0 0 ${options.iconMargin}px 0`
        : `${options.iconMargin}px 0 0 0`
    },
    getIconStyle() {
      const options = this.getDynamicOptions
      return {
        display: "inline-block",
        // "--color": options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : options.iconColor.color
        //   ? options.iconColor.color
        //   : options.iconColor,
        "--color": this.$parseColor(options.iconColor, {
          isThemeColor: options.iconColorIsThemeColor
        }),
        fontSize: options.iconWidth + "px",
        width: options.iconWidth + "px",
        height: options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      const options = this.getDynamicOptions
      return {
        width: options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      const options = this.getDynamicOptions
      let tmpStyle = ""
      const { boxShadowH, boxShadowV, boxShadowBlur, boxShadowSpread, boxShadowColor } = options
      if (Array.isArray(boxShadowH)) {
        boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${boxShadowH[index]}px ${boxShadowV[index]}px ${boxShadowBlur[index]}px ${boxShadowSpread[index]}px ${this.$parseColor(boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${boxShadowH}px ${boxShadowV}px ${boxShadowBlur}px ${boxShadowSpread}px ${this.$parseColor(boxShadowColor)}`
      }
      return tmpStyle
    },
    textShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.textShadowH)) {
        this.options.textShadowH.forEach((item, index) => {
          if (index > 0) {
            // tmpStyle += ","
            tmpStyle += " "
          }
          tmpStyle += `drop-shadow(${this.options.textShadowH[index]}px ${this.options.textShadowV[index]}px ${this.options.textShadowBlur[index]}px ${this.$parseColor(this.options.textShadowColor[index])})`
        })
      } else {
        tmpStyle += `drop-shadow(${this.options.textShadowH}px ${this.options.textShadowV}px ${this.options.textShadowBlur}px ${this.$parseColor(this.options.textShadowColor)})`
      }
      return tmpStyle
    },
    // 获取文字颜色
    colorStyle() {
      const options = this.getDynamicOptions
      let colorStyle = {}
      let colorArr = this.checkAndSetPrimaryVal(options, "colorArr", "colorArr", "{}")
      let tmp = []
      if (options) {
        if (options.textIsThemeColor) {
          colorStyle = {
            color: this.themeColor
          }
        } else {
          if (!(JSON.parse(JSON.stringify(colorArr)) == "{}")) {
            colorArr.data.stops?.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            if (colorArr.label === "线性渐变") {
              colorStyle = {
                color: "transparent",
                // backgroundImage: `-webkit-linear-gradient(${colorArr.data.angle}deg, ${tmp.join(",")})`,
                backgroundImage: this.$parseColor(colorArr),
                "-webkit-background-clip": "text",
                "-webkit-line-clamp": options.textLimitLines
              }
            } else if (colorArr.label === "颜色") {
              colorStyle = {
                // color: options.textIsThemeColor ? this.themeColor : (colorArr.data.stops?.[0][0] || colorArr.color), 
                color: this.$parseColor(colorArr, {
                  isThemeColor: options.textIsThemeColor
                }),
                "-webkit-line-clamp": options.textLimitLines
              }
            }
          } else {
            colorStyle = {
              // color: options.textIsThemeColor ? this.themeColor : options.color,
              color: this.$parseColor(options.color, {
                isThemeColor: options.textIsThemeColor
              }),
              "-webkit-line-clamp": options.textLimitLines
            }
          }
        }
        return colorStyle
      } else {
        return null
      }
    },
    // 获取背景颜色
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      const options = this.getDynamicOptions
      let curBackground = options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: options.hasOwnProperty("bgColorIsThemeColor") ? options.bgColorIsThemeColor : false,
            color: options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            if (bg.imgUrl) {
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
            }
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            containerBg.backgroundImage = this.setBorderColor(containerBg.backgroundColor,containerBg.backgroundImage)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops?.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops?.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      if (this.options.showBorder !== false && this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor)) {
        containerBg.backgroundClip = "padding-box,border-box"// 圆角裁切
        containerBg.backgroundOrigin = "padding-box,border-box"
      }
      return containerBg
    },
    alignStyle(){
      let alignStyleObj ={}
      let alignItems = "center", textAlign = "center"
      // 兼容之前有textAlign属性，但是textAlign为left,但是按钮显示默认为center
      if(this.options.hasTextAlign){
        switch(this.options.textAlign){
          case 'left':
            alignItems = 'flex-start'
            textAlign = "left"
            break
          case 'center':
            alignItems = 'center'
            textAlign = "center"
            break
          case 'right':
            alignItems = 'flex-end'
            textAlign = "right"
            break
          default:
        }
      }
      if(this.getIconPosition === 'top' || this.getIconPosition === 'bottom'){
        alignStyleObj = {
          alignItems: alignItems,
          textAlign: textAlign
        }
      }else{
        alignStyleObj = {
          justifyContent:alignItems,
          textAlign: textAlign
        }
      }
      return alignStyleObj
    },
    // 文字整体样式
    getTextStyle() {
      const options = this.getDynamicOptions
      if (options) {
        let borderW = ""
        if (Array.isArray(options.borderWidth)) {
          options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${options.borderWidth}px`
        }
        let cursor
        if (this.request_prefix === "bigScreen" && this.isBigScreenPreview()) {
          cursor = this.options.cursorType ? this.options.cursorType:this.options.linkUrl ? "pointer" : "default"
        }
        let thisStyle = {
          ...this.alignStyle,
          height: "100%",
          "letter-spacing":
            options.letterSpacingType === "%" ? options.letterSpacing / 100 + "em" : options.letterSpacing + "px",
          "font-style": `${options.fontStyle}`,
          "font-family": options.fontFamily,
          opacity: options.opacity,
          // color: options.textIsThemeColor ? this.themeColor : options.color,
          color: this.$parseColor(options.color, {
            isThemeColor: options.textIsThemeColor
          }),
          "font-size": options.fontSize + "px",
          "font-weight": options.fontWeight,
          "text-decoration": options.textDecoration,
          transform: "rotate(" + options.rotate + "deg)",
          "border-style": options.borderStyle,
          // "border-color": this.borderColorType && this.borderColorType !== "color" ? "transparent" : options.borderIsThemeColor
          //   ? this.themeColor
          //   : options.borderColor.color
          //   ? options.borderColor.color
          //   : options.borderColor,
          "border-color": this.isGradientBorder(options.borderColor, options.borderIsThemeColor) ? "transparent" : this.$parseColor(options.borderColor, {
            isThemeColor: options.borderIsThemeColor
          }),
          "border-width": options.showBorder !== false ? borderW : 0,
          "box-shadow": this.boxShadowStyle,
          "filter": this.textShadowStyle,
          "border-top-left-radius":
            options.shapeType == "round" ? options.borderTopLeftRadius : options.borderTopLeftRadius + "px",
          "border-top-right-radius":
            options.shapeType == "round" ? options.borderTopLeftRadius : options.borderTopRightRadius + "px",
          "border-bottom-left-radius":
            options.shapeType == "round" ? options.borderTopLeftRadius : options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius":
            options.shapeType == "round" ? options.borderTopLeftRadius : options.borderBottomRightRadius + "px",
          cursor: cursor,
          padding: this.getPaddingStyle
        }
        return {
          ...this.bgStyle,
          ...this.colorStyle,
          ...thisStyle
        }
      } else return null
    },
    // 获取动态的配置项，包括状态标签配置
    getDynamicOptions() {
      if (this.options) {
        if (this.options.conditionList) {
          const content = this.getContent
          let match = false
          let matchIndex = -1
          const isExpression = this.options.pluginName?.includes("expressionPlugin")
          for (let i = 0; i < this.options.conditionList.length; i++) {
            let { value, result } = this.options.conditionList[i]
            if (isExpression) {
              try {
                if (eval(value.replace(/\${value}/g, content)) === true) {
                  this.contentResult = result.replace(/\${value}/g, content) || result
                  match = true
                }
              } catch (error) {
                console.log("自定义表达式错误")
              }
            } else {
              if (content === value) {
                this.contentResult = result
                match = true
              }
            }
            if (match) {
              matchIndex = i
              break
            }
          }
          this.matched = match
          if (match) {
            const dynamicOptions = this.options.conditionList[matchIndex].options
            return {
              ...this.options,
              ...dynamicOptions
            }
          } else {
            this.contentResult = ""
            return this.options
          }
        }
        return this.options
      }
      return null
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    }
  },
  methods: {
    textClickEvent() {
      // 预览页面使用
      if (!this.options.linkUrl) {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.request_prefix !== "bigScreen" && !isSsrPage()) {
        return
      }
      const spliceUrl = spliceLinkUrl(this)
      if (this.options.openBlankPage) {
        window.open(spliceUrl || this.options.linkUrl, "_blank")
      } else {
        window.location.href = spliceUrl || this.options.linkUrl
      }
    },
    async updateData() {
      this.updateNormalRect.call(this, (datas, linkUrl) => {
        if (typeof datas === "string") {
          this.$changeOptionsEV(datas, "content", false, false, false, true)
          this.$changeOptionsEV(linkUrl, "linkUrl", false, false, false, true)
          return
        }
        const data = datas[0]
        let fieldList = []
        if (data) {
          Object.keys(data).map((key, item) => {
            if (Object.prototype.toString.call(data[key]) === "[object Object]") {
              // 判断是否为Object
              const param = {
                label: data[key].key,
                value: data[key].value
              }
              fieldList.push(param)
            }
          })
          if(this.options.linkAddress === "数据源"){
            this.$changeOptionsEV(data.url, "linkUrl", false, false, false, true)
          }
        }
        this.$changeOptionsEV(fieldList, "fieldList", false, false, false, true)
      })
    },
    dbEditContent() {
      if (this.isBigScreenPreview() || this.options.appId) {
        return
      }
      this.isEditStatu = true
      this.tempContent = this.getTextContent
      this.$nextTick(()=>{
        // this.$refs.buttonInp.focus()
        this.$refs.buttonInp.select()
      })
      sessionStorage.setItem("isBtnEditStatu", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      // this.$nextTick(() => {
      //   this.getSelectPos()
      // })
    },
    // 将光标移动到最后面
    getSelectPos() {
      // let esrc = this.$refs.btnInner
      // let range = document.createRange()
      // range.selectNodeContents(esrc)
      // range.collapse(false)
      // let sel = window.getSelection()
      // sel.removeAllRanges()
      // sel.addRange(range)
    },
    blueEvent(){
      sessionStorage.removeItem("isBtnEditStatu")
      this.isEditStatu = false
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      this.$changeOptionsEV(this.tempContent, "content", false, undefined, this.activeIds)
    },
    keyDownEvent() {
      let _this = this
      let key = window.event.keyCode
      // esc键   取消克隆模式
      if (key === 13 && _this.isEditStatu) {
        this.blueEvent()
      }
    }
  }
}
</script>

<style scoped>
.label-container {
  width: 100%;
  height: 100%;
}
.cx-button {
  position: relative;
  line-height: 100%;
  pointer-events: none;
}
.label-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  transition: transform 0.5s;
}

.label-inner.column {
  flex-direction: column;
}

::v-deep.label-inner svg * {
  stroke: var(--color);
}
.button-inp{
  background: transparent;
  color: inherit!important;
  font-size: inherit !important;
  max-width: 100%;
  text-align: center;
}
</style>
